<template lang="pug">
  .mapView(v-if='hasAddress')
    .row
      .col-md-8
        .map
      .col-md-4
        .row
          .col-md-6
            div
              small.text-muted {{$t('events.yourAddress')}}
                | &nbsp; (
                a(role='button', @click="toggleUserAddressEditing") {{$t('globals.edit')}}
                | )

              p(v-if='userAddress.length > 0') {{userAddress}}
              p(v-else) {{$t('events.addressToDefined')}}
          .col-md-6
            div
              small.text-muted {{$t('events.address')}}
                template(v-if="canEditAddress")
                  | &nbsp; (
                  a(role='button', @click="emitEdit") {{$t('globals.edit')}}
                  | )
              p {{address}}
        template(v-if='isUserAddressEditing')
          .alert.alert-info(v-if='userAddress.length == 0') {{$t('events.needYourAddress')}}
          user-address-edition(:btnText='$t("events.showPath")', @saved='userAddressSaved')
        template(v-else)
          .directions
          .pull-right
            a.btn.btn-xs(:href="gmapsUrl", target="_blank", rel='noopener') {{$t('events.toGoogleMaps')}}
              | &nbsp;
              i.fa.fa-long-arrow-right
  .padding(v-else)
    .text-center
      h5 {{$t("events.noAddress")}}
      br
      a.btn.btn-primary(@click="emitEdit", v-if="canEditAddress") {{$t('events.defineAnAddress')}}

</template>
<script>
import $ from 'jquery'

import Vue from 'vue'
import {mapGetters} from 'vuex'

import UserAddressEdition from '@/components/shared/UserAddressEdition'

export default {
  props: {
    address: {
      type: String,
      required: false,
      default: ''
    },
    canEditAddress: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      addressEditing: false
    }
  },
  components: {
    UserAddressEdition
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    hasAddress () {
      return this.address.trim().length !== 0
    },
    userAddress () {
      return ((this.user.address.street || '') + ' ' + (this.user.address.city || '') + ' ' + (this.user.address.country || '')).trim()
    },
    isUserAddressEditing () {
      return this.userAddress.length === 0 || this.addressEditing
    },
    gmapsUrl () {
      return 'https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(this.userAddress) + '&destination=' + encodeURIComponent(this.address)
    }
  },
  mounted () {
    this.installMap()
  },
  methods: {
    installMap () {
      var mapCanvas = $('.map', this.$el)[0]
      // if map already generated
      if (!mapCanvas) {
        return
      }
      $(mapCanvas).empty()
      if (window.google) {
        try {
          let google = window.google
          var directionsService = new google.maps.DirectionsService()
          let directionsDisplay = new google.maps.DirectionsRenderer()
          directionsDisplay.setPanel($('.directions', this.$el)[0])
          let geocoder = new google.maps.Geocoder()
          geocoder.geocode({
            address: this.address
          }, (results, status) => {
            if (status === 'OK') {
              let latlng = results[0].geometry.location
              let map = new google.maps.Map(mapCanvas, {
                center: {
                  lat: latlng.lat(),
                  lng: latlng.lng()
                },
                zoom: 18
              })
              if (results[0].geometry.viewport) {
                map.fitBounds(results[0].geometry.viewport)
              }
              directionsDisplay.setMap(map)
              /* eslint-disable no-new */
              new google.maps.Marker({
                position: {
                  lat: latlng.lat(),
                  lng: latlng.lng()
                },
                title: this.address,
                map: map
              })
              if (this.userAddress.length > 0) {
                directionsService.route({
                  origin: this.userAddress,
                  destination: this.address,
                  travelMode: 'DRIVING'
                }, (response, status) => {
                  if (status === 'OK') {
                    directionsDisplay.setDirections(response)
                  } else {
                    $('.directions', this.$el).html('Aucune route possible. Veuillez vérifier vos adresses.')
                  }
                })
              }
            } else {
              $(mapCanvas).html('<div class="text-center"><i class="fa fa-map-o fa-4x" style="margin-top: 30px; margin-bottom: 30px"></i><br>' + Vue.i18n.t('events.noMapCoordinates') + '</div>')
            }
          })
        } catch (e) {
          $(mapCanvas).html(Vue.i18n.t('globals.error'))
        }
      } else {
        $(mapCanvas).html(Vue.i18n.t('globals.error'))
      }
    },
    emitEdit () {
      this.$emit('editAddress')
    },
    userAddressSaved () {
      if (this.addressEditing) {
        this.toggleUserAddressEditing()
      }
    },
    toggleUserAddressEditing () {
      this.addressEditing = !this.addressEditing
    }
  },
  watch: {
    isUserAddressEditing () {
      if (!this.isUserAddressEditing) {
        this.$nextTick(() => {
          this.installMap()
        })
      }
    },
    'user.address': {
      deep: true,
      handler: function () {
        this.$nextTick(() => {
          this.installMap()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MapView.vue?5e536a12